function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavHelpMobile = function SvgNavHelpMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3,
    cy: 24.4,
    r: 11.5,
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 1.3,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M12.3 12.1h23.9V36H12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 27v-.7c-.2-.7-.1-1 .3-1.5l1.1-1.6c.6-.8.8-1.2.8-1.8 0-1-.7-1.6-1.7-1.6s-1.6.6-1.8 1.6c0 .1-.1.2-.2.1l-1.1-.2c-.1 0-.2-.1-.1-.2.3-1.6 1.4-2.7 3.2-2.7 1.9 0 3.1 1.2 3.1 2.9 0 .8-.3 1.4-.9 2.2l-1.1 1.6c-.3.5-.4.7 0 1.3v.6c-.4.1-.5.2-.6-.1l-1 .1c-.2.2-.2.1 0 0zm.2 1.5h1.3c.1 0 .2.1.2.2V30c0 .1-.1.2-.2.2H24c-.1 0-.2-.1-.2-.2v-1.3c0-.1.1-.2.2-.2z",
    style: {
      fill: "#231f20"
    }
  }));
};
export default SvgNavHelpMobile;